import { memo } from 'react';

import { connect } from 'react-redux';
import type { ConnectedProps } from 'react-redux';
import { compose } from 'recompact';

import { Variant } from 'src/app/components/Header/constants';
import { errorBoundary } from 'src/app/hocs';
import {
  getStarted,
  loggedInPromoOnboardingPage,
  loggedOutPromoOnboardingWaitlist,
  loggedOutPromoOnboardingWaitlistSuccess,
  promoLinkedSuccessfully,
} from 'src/app/router/paths';
import { isLoggedIn } from 'src/app/state/selectors';
import type { RootState } from 'src/app/state/store';
import { arePathnamesEqual } from 'src/app/utils';

import { MarketingRenderer } from '.';

const mapStateToProps = (state: RootState) => {
  const pathname = state.router.location.pathname;

  // TODO: use createMatchSelector
  const isNewOnboarding = pathname.startsWith('/rx/onboarding/');
  const isGetStartedPage = arePathnamesEqual(pathname, getStarted.toPath());
  const isPromotionalPage = /\/l\/[a-zA-Z0-9-]*$/.test(pathname);
  const isPromoOnboardingPage = arePathnamesEqual(pathname, loggedInPromoOnboardingPage.toPath());
  const isPromoLinkedSuccessfullyPage = arePathnamesEqual(pathname, promoLinkedSuccessfully.toPath());
  const isPromoOnboardingWaitList = arePathnamesEqual(pathname, loggedOutPromoOnboardingWaitlist.toPath());
  const isPromoOnboardingWaitListSuccess = arePathnamesEqual(
    pathname,
    loggedOutPromoOnboardingWaitlistSuccess.toPath()
  );

  const hasSimpleNav =
    isGetStartedPage || isPromoOnboardingPage || isPromoOnboardingWaitList || isPromoOnboardingWaitListSuccess;

  return {
    navVariant: hasSimpleNav ? Variant.simple : Variant.base,
    isLoggedIn: isLoggedIn(state),
    isNewOnboarding,
    isPromoOnboardingPage,
    isPromoLinkedSuccessfullyPage,
    isFooterShown:
      !isNewOnboarding &&
      !isGetStartedPage &&
      !isPromotionalPage &&
      !isPromoOnboardingPage &&
      !isPromoOnboardingWaitList &&
      !isPromoOnboardingWaitListSuccess,
    pathname,
  };
};

const connector = connect(mapStateToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export const Marketing = compose(errorBoundary, connector, memo)(MarketingRenderer);

Marketing.displayName = MarketingRenderer.displayName;
